import { render, staticRenderFns } from "./SelectScreen.vue?vue&type=template&id=65f7dc3e&scoped=true&"
import script from "./SelectScreen.vue?vue&type=script&lang=js&"
export * from "./SelectScreen.vue?vue&type=script&lang=js&"
import style0 from "./SelectScreen.vue?vue&type=style&index=0&id=65f7dc3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7dc3e",
  null
  
)

export default component.exports